<form [formGroup]="formContact">
  <div class="card m-3">
    <h5 class="card-header">Contact Information <span class="legend-label">{{requiredLegend}}</span></h5>
    <div class="card-body">
      <div class="row p-3">
        <div class="col" style="margin-left: 60px;">
          <div class="form-group row">
            <label for="kaizenCreator" class="col-sm-4 col-form-label">Kaizen Creator *</label>
            <div class="col-sm-5 p-1">
              <div class="autocomp">
                <mat-form-field>
                  <input matInput type="text" placeholder="Pick Kaizen Creator" aria-label="Kaizen Creator" id="kaizenCreator"
                    [formControl]="kaizenCreatorControl" [matAutocomplete]="auto1" required
                    [class.invalid]="kaizenCreatorControl.invalid && kaizenCreatorControl.touched" />
                    <mat-autocomplete #auto1="matAutocomplete">
                      @for (option of filteredKaizenCreator | async; track option) {
                        <mat-option [value]="option.emailId">{{ option.emailId }}
                        </mat-option>
                      }</mat-autocomplete>
                      @if (!kaizenCreatorValid && kaizenCreatorControl.touched) {
                        <small class="invalid">
                          Please enter a valid email address
                        </small>
                      }
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="kaizenLeader" class="col-sm-4 col-form-label">Kaizen Leader *</label>
                <div class="col-sm-8 p-1 autocomp">
                  <mat-form-field  appearance="fill">
                    <input type="text" placeholder="Pick Kaizen Leader" aria-label="Number" matInput id="kaizenLeader"
                      [formControl]="kaizenLeaderControl" [matAutocomplete]="auto2" required
                      [class.invalid]="kaizenLeaderControl.invalid && kaizenLeaderControl.touched">
                      <mat-autocomplete #auto2="matAutocomplete">
                        @for (option of  filteredKaizenLeader| async; track option) {
                          <mat-option [value]="option.emailId">
                            {{option.emailId}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      @if (!kaizenLeaderValid && kaizenLeaderControl.touched) {
                        <small class="invalid"
                          >Please enter a valid email address
                        </small>
                      }
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="supportingMembers" class="col-sm-4 col-form-label">Supporting Members:</label>
                  <div class="col-sm-6 p-1 autocomp">
                    <mat-form-field  appearance="fill">
                      <input type="text" placeholder="Enter Supporting Member then Press Button" aria-label="Number" matInput id="supportingMembers"
                        [formControl]="kaizenSupporterControl" >
                      </mat-form-field>
                    </div>
                    <div class="col-sm-2"><button mat-flat-button color="primary" (click)="addSupportingMember()" >
                      <mat-icon class="icoPluss">add_circle_outline</mat-icon>
                    </button>

                  </div>
                </div>
              </div>
              <div class="col-md-auto">

              </div>
              <div class="col col-lg-4">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th>Supporting Member List</th>
                      <th>Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    @for (member of supportingMembers; track member; let i = $index) {
                      <tr>
                        <td>{{member}}
                          <td><i class="material-icons icoMinus" (click)="removeSupportingMember(i)" >remove_circle_outline</i></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </form>